<template>
  <div class="contact-us">
    <headers></headers>
    <div class="contact-con">
      <div class="content">
        <div class="title">中国国际贸易促进委员会</div>
        <div class="title title-border">中国国际商会调解中心</div>
        <div class="icon-box"> <img class="icon" src="./imgs/location.png" alt="地址">北京市西城区桦皮厂胡同2号国际商会大厦4层</div>
        <div class="contact"><i>官网：</i>https://adr.ccpit.org/</div>
        <div class="contact"><i>电话：</i>010-82217081 / 82217150<div class="phone">82217080 / 82217063</div> </div>
        <div class="contact"><i>邮箱：</i>adr@ccpit.org</div>
        <div class="contact"><i>传真：</i>010-82217052</div>
        <div class="contact"><i>邮编：</i>100035</div>
      </div>
    </div>
  </div>
</template>

<script>
import headers from "@/components/header";
export default {
  name: "contactUs",
  data() {
    return {
    };
  },
  components: {
    headers,
  },
  watch: {
  },
  methods: {
  },
  mounted() {

  },
  updated(){
  },  
};
</script>

<style scoped lang="scss">
.contact-us{
  padding-top: 50px;
  box-sizing: border-box;
  height: 100%;
  .header{
    margin-top: -50px;
  }
  .contact-con{
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    background: url('./imgs/contact.png') no-repeat;
    background-size: 100%;
    .content{
      position: absolute;
      top: 100px;
      bottom: 20px;
      width: 90%;
      background: #FFFFFF;
      box-shadow: 0px 0px 17px 0px rgba(17, 123, 201, 0.14);
      border-radius: 17px;
      padding: 15px 15px 50px; 
      box-sizing: border-box; 
      font-weight: 400;
      color: #333333;
      line-height: 32px;
      font-size: 14px;
      .title{
        font-size: 20px;
        line-height: 32px;
      } 
      .title-border{
        border-bottom: 1px solid rgba(238, 238, 238, 1);
        position: relative;
        padding-bottom: 14px;
        &::after{
          content: '';
          display: block;
          width: 20px;
          height: 3px;
          background: #376BFF;
          border-radius: 1px;
          position: absolute;
          top: 44px;
          left: 0px;
        }
      }
      .icon-box{
        display: flex;
        align-items: center;
        line-height: 54px;
        .icon{
          width: 12px;
          height: 16px;
          margin-right: 10px;
        }
      }
      .contact{
        i{
          font-style: normal;
          color: #999;
        } 
        .phone{
          text-indent: 40px;
        }
      }
    }
  }
}
</style>
